import React from 'react';
import SharedMaps from "./SharedMaps.js";
/**
 * Creates and installs the Theme Provider. This requires Molten to have a config
 * with theme : { theme, activeThemeId, useActiveTheme }. The theme should be the
 * css version of the theme. If the activeThemeId is supplied, it will be used if
 * NODE_ENV is 'development' or useActiveTheme is true.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  type: 'molten.mapDataView.Support',
  sort: -5,
  createSupportComponents: molten => {
    return [/*#__PURE__*/_jsx(SharedMaps, {}, "theme.maps")];
  }
};